import React from "react";
import { Checkbox } from "antd";
import "./UploadAgreement.scss";

const UploadAgreement = ({ checked, onChange }) => {
  return (
    <div className="upload-agreement">
      <Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)}>
        我已阅读并接受
      </Checkbox>
      <a
        href="/agreements/upload.html"
        target="_blank"
        className="agreement-link"
      >
        《内容上传规范》
      </a>
    </div>
  );
};

export default UploadAgreement;
